import React from 'react';
import { useController } from 'react-hook-form';
import clx from 'classnames';
import Tooltip from 'components/Tooltip';
import Icon from 'components/Icon';

interface IOption {
  label: string;
  value: string;
}

type AppProps = {
  label: string;
  name: string;
  className?: string;
  control: any;
  error?: string;
  loading?: boolean;
  required?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  options: IOption[];
  info?: string;
};

const Switcher: React.FC<AppProps> = ({
  name,
  label,
  control,
  className = '',
  error = null,
  required = false,
  loading = false,
  onChange = () => null,
  disabled = false,
  options,
  info = '',
}) => {
  const { field } = useController({ name, control });

  const handleChange = (v: any) => {
    const next = field.value === v ? '' : v;
    field.onChange(next);
    onChange(next);
  };

  return (
    <div className={className}>
      <div className="text-text-medium text-sm v-center space-x-2 mb-2">
        <div>
          {label}
          {required && <span className="text-error">*</span>}
        </div>
        {!!info && (
          <div>
            <Tooltip tooltipContent={info} width="240px">
              <Icon
                name="info"
                size={14}
                className="text-text-lighter relative"
              />
            </Tooltip>
          </div>
        )}
      </div>
      <div className="flex space-x-2">
        {options.map((option) => (
          <div
            key={option.value}
            onClick={() => handleChange(option.value)}
            className={clx(
              'px-2 py-1.5 rounded text-sm font-medium cursor-pointer',
              {
                'bg-primary-negative text-text-medium':
                  field.value !== option.value,
                'bg-primary text-white': field.value === option.value,
              }
            )}
          >
            {option.label}
          </div>
        ))}
      </div>
      {error && <div className="text-error text-xs mt-1">*{error}</div>}
    </div>
  );
};

Switcher.displayName = 'Switcher';

export default Switcher;
